<template>
  <div id="products" class="px-4 pb-4">
    <product-list
      @enable-action="disabled = false"
      @disable-action="disabled = true"
    />
  </div>
</template>
<script>
import ProductList from "@/components/product_management/ProductList";

export default {
  components: {
    ProductList
  },
  data: () => ({
    disabled: true,
    actions: [
      {
        value: 1,
        text: "Update Status"
      },
      {
        value: 2,
        text: "Update Brand"
      },
      {
        value: 3,
        text: "Update Supplier"
      }
    ],
    items: []
  }),
  computed: {}
};
</script>
